import { Injectable } from '@angular/core';
import { ResourcesService } from './resources.service';
import { SiteContentService } from './site-content.service';
import { UserStepService } from './user-step.service';
import { UserCardioService } from './user-cardio.service';
import { UserStrengthWorkoutService } from './user-strength-workout.service';
import { UserBreathWorkoutService } from './user-breath-workout.service';
import { UserDrinksService } from './user-drinks.service';
import { UserEatWellService } from './user-eat-well.service';
import { UserSmokingService } from './user-smoking.service';
import { UserFeelsService } from './user-feels.service';
import { UserSleepsService } from './user-sleeps.service';
import { UserTaskStatusService } from './user-task-status.service';
import { UserTargetService } from './user-target.service';

@Injectable({
  providedIn: 'root',
})
export class CacheManagerService {
  constructor(
    private resoucesService: ResourcesService,
    private siteContentService: SiteContentService,
    private userStepService: UserStepService,
    private userCardioService: UserCardioService,
    private userStrengthWorkoutService: UserStrengthWorkoutService,
    private userBreathWorkoutService: UserBreathWorkoutService,
    private userDrinksService: UserDrinksService,
    private userEatWellService: UserEatWellService,
    private userSmokingService: UserSmokingService,
    private userFeelsService: UserFeelsService,
    private userSleepsService: UserSleepsService,
    private userTaskStatusService: UserTaskStatusService,
    private userTargetService: UserTargetService
  ) {}

  clearAllCache() {
    this.resoucesService.clearCache();
    this.siteContentService.clearCache();
    this.userStepService.clearCache();
    this.userCardioService.clearCache();
    this.userStrengthWorkoutService.clearCache();
    this.userBreathWorkoutService.clearCache();
    this.userDrinksService.clearCache();
    this.userEatWellService.clearCache();
    this.userSmokingService.clearCache();
    this.userFeelsService.clearCache();
    this.userSleepsService.clearCache();
    this.userTaskStatusService.clearCache();
    this.userTargetService.clearCache();
  }
}
